import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import App from './App';
import { DeckProvider } from './lib/deckContext';
import { initMsal, msalInstance } from './lib/auth/msal';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

const root = createRoot(rootEl);

function renderApp() {
  const inner = (
    <StrictMode>
      <BrowserRouter>
        <DeckProvider>
          <App />
        </DeckProvider>
      </BrowserRouter>
    </StrictMode>
  );

  // Wrap with MsalProvider only when MSAL is actually configured. In bypass
  // mode there's no instance to provide, and we skip the wrapper so the rest
  // of the app doesn't need to care.
  root.render(
    msalInstance ? <MsalProvider instance={msalInstance}>{inner}</MsalProvider> : inner,
  );
}

// initMsal handles the post-redirect callback when returning from Entra.
// It's a no-op in bypass mode, so this works either way.
initMsal()
  .catch((err) => {
    console.error('[auth] MSAL init failed', err);
  })
  .finally(renderApp);
